/* eslint-disable */
import { defineMessages } from "react-intl";

const PREFIX = "HelpPage";
export default defineMessages({
  collapseAllButton: {
    id: `${PREFIX}.collapseAllButton`,
    defaultMessage: "Collapse all",
  },
  expandAllButton: {
    id: `${PREFIX}.expandAllButton`,
    defaultMessage: "Expand all",
  },
  dataUpdateCalendarName: {
    id: `${PREFIX}.dataUpdateCalendarName`,
    defaultMessage: "Data update calendar",
  },
  dataUpdateCalendarDescription: {
    id: `${PREFIX}.dataUpdateCalendarDescription`,
    defaultMessage: "Gives an indicative overview of data update timeline",
  },
  definitionOfSourcesForAPOfficialName: {
    id: `${PREFIX}.definitionOfSourcesForAPOfficialName`,
    defaultMessage: "Definition of sources for AP official",
  },
  definitionOfSourcesForAPOfficialDescription: {
    id: `${PREFIX}.definitionOfSourcesForAPOfficialDescription`,
    defaultMessage: "Defines which source is used for which crop",
  },
  DataAvailabilityOfAPOfficialHarmonizedDatasetName: {
    id: `${PREFIX}.DataAvailabilityOfAPOfficialHarmonizedDatasetName`,
    defaultMessage: "Data availability of AP official harmonized dataset",
  },
  DataAvailabilityOfAPOfficialHarmonizedDatasetDescription: {
    id: `${PREFIX}.DataAvailabilityOfAPOfficialHarmonizedDatasetDescription`,
    defaultMessage: "Defines the availability of data in AP Official Dataset",
  },
  BackgroundInformationOnSourcesName: {
    id: `${PREFIX}.BackgroundInformationOnSourcesName`,
    defaultMessage: "Background information on sources",
  },
  BackgroundInformationOnSourcesDescription: {
    id: `${PREFIX}.BackgroundInformationOnSourcesDescription`,
    defaultMessage: "This section provides general information about the data sources in the application",
  },
  UserGuideName: {
    id: `${PREFIX}.UserGuideName`,
    defaultMessage: "User guide",
  },
  UserGuideDescription: {
    id: `${PREFIX}.UserGuideDescription`,
    defaultMessage: "A comprehensive guideline on how to use the AP Agriculture Terminal application",
  },
  IntroName: {
    id: `${PREFIX}.IntroName`,
    defaultMessage: "AgTerminal Intro",
  },
  FormulasName: {
    id: `${PREFIX}.FormulasName`,
    defaultMessage: "Definitions and formulas",
  },
  FormulasDescription: {
    id: `${PREFIX}.FormulasDescription`,
    defaultMessage: "Formulas used for calculated Attributes",
  },
  GlobalSlidesName: {
    id: `${PREFIX}.GlobalSlidesName`,
    defaultMessage: "Global slides description",
  },
  GlobalSlidesDescription: {
    id: `${PREFIX}.GlobalSlidesDescription`,
    defaultMessage: "Explanation of the predefined Global Unit Slides and the used sources for the given information",
  },
  APESlidesName: {
    id: `${PREFIX}.APESlidesName`,
    defaultMessage: "APE slides description",
  },
  APESlidesDescription: {
    id: `${PREFIX}.APESlidesDescription`,
    defaultMessage: "Explanation of the predefined APE Unit Slides and the used sources for the given information",
  },
  NeedSomeHelp: {
    id: `${PREFIX}.NeedSomeHelp`,
    defaultMessage: "Need some help?",
  },
  GoUp: {
    id: `${PREFIX}.GoUp`,
    defaultMessage: "Go Up",
  },
  ContactUs: {
    id: `${PREFIX}.ContactUs`,
    defaultMessage: "Contact us",
  },
  HelpTopics: {
    id: `${PREFIX}.HelpTopics`,
    defaultMessage: "Help",
  },
  Sections: {
    id: `${PREFIX}.Sections`,
    defaultMessage: "Sections",
  },
  Crops: {
    id: `${PREFIX}.Crops`,
    defaultMessage: "Crops",
  },
  APOfficialCropsDataset: {
    id: `${PREFIX}.APOfficialCropsDataset`,
    defaultMessage: "AP official crops dataset",
  },
  USDA: {
    id: `${PREFIX}.USDA`,
    defaultMessage: "USDA PS&D",
  },
  UNFAO: {
    id: `${PREFIX}.UNFAO`,
    defaultMessage: "UN FAO ProdSTAT",
  },
  FAO: {
    id: `${PREFIX}.FAO`,
    defaultMessage: "FAO - OECD Agricultural Outlook",
  },
  FAPRI: {
    id: `${PREFIX}.FAPRI`,
    defaultMessage: "FAPRI",
  },
  USDACrop: {
    id: `${PREFIX}.USDACrop`,
    defaultMessage: "USDA crop forecast",
  },
  Prices: {
    id: `${PREFIX}.Prices`,
    defaultMessage: "Prices",
  },
  APPrices: {
    id: `${PREFIX}.APPrices`,
    defaultMessage: "AP official prices dataset",
  },
  APForecast: {
    id: `${PREFIX}.APForecast`,
    defaultMessage: "AP official forecast prices dataset",
  },
  AlternativePrice: {
    id: `${PREFIX}.AlternativePrice`,
    defaultMessage: "Alternative price datasets",
  },
  Macroeconomy: {
    id: `${PREFIX}.Macroeconomy`,
    defaultMessage: "Macroeconomy",
  },
  Trade: {
    id: `${PREFIX}.Trade`,
    defaultMessage: "Trade",
  },
  APTrade: {
    id: `${PREFIX}.APTrade`,
    defaultMessage: "AP official trade flow dataset",
  },
  Docs: {
    id: `${PREFIX}.Docs`,
    defaultMessage: "Docs",
  },
  Daily: {
    id: `${PREFIX}.Daily`,
    defaultMessage: "Daily updates",
  },
  EveryDay: {
    id: `${PREFIX}.EveryDay`,
    defaultMessage: "Every day",
  },
  Weekly: {
    id: `${PREFIX}.Weekly`,
    defaultMessage: "Weekly updates",
  },
  Wednesday: {
    id: `${PREFIX}.Wednesday`,
    defaultMessage: "Every wednesday",
  },
  FAOCommodityPrices: {
    id: `${PREFIX}.FAOCommodityPrices`,
    defaultMessage: "FAO international commodity prices",
  },
  ICEEURONEXT: {
    id: `${PREFIX}.ICEEURONEXT`,
    defaultMessage: "ICE, EURONEXT and USDA field crops prices",
  },
  DAX: {
    id: `${PREFIX}.DAX`,
    defaultMessage: "DAX and S&P 500 index values",
  },
  Gold: {
    id: `${PREFIX}.Gold`,
    defaultMessage: "Gold prices",
  },
  NYSE: {
    id: `${PREFIX}.NYSE`,
    defaultMessage: "NYSE and CBOT futures prices",
  },
  DailyNASDAQ: {
    id: `${PREFIX}.DailyNASDAQ`,
    defaultMessage: "NASDAQ daily commodity",
  },
  CFTC: {
    id: `${PREFIX}.CFTC`,
    defaultMessage: "CFTC trader data for futures",
  },
  IGC: {
    id: `${PREFIX}.IGC`,
    defaultMessage: "IGC Grains and Oilseeds Index (GOI)",
  },
  Friday: {
    id: `${PREFIX}.Friday`,
    defaultMessage: "Every friday",
  },
  EIAOil: {
    id: `${PREFIX}.EIAOil`,
    defaultMessage: "EIA crude oil prices",
  },
  Monthly: {
    id: `${PREFIX}.Monthly`,
    defaultMessage: "Monthly updates",
  },
  By15month: {
    id: `${PREFIX}.By15month`,
    defaultMessage: "By the 15th of every month",
  },
  USDAAgrPrices: {
    id: `${PREFIX}.USDAAgrPrices`,
    defaultMessage: "USDA agricultural prices",
  },
  Fertilizer: {
    id: `${PREFIX}.Fertilizer`,
    defaultMessage: "Fertilizer prices (USDA & world bank)",
  },
  IMFprices: {
    id: `${PREFIX}.IMFprices`,
    defaultMessage: "IMF prices",
  },
  UNCOMTRADE: {
    id: `${PREFIX}.UNCOMTRADE`,
    defaultMessage: "UN COMTRADE",
  },
  USDAPSD: {
    id: `${PREFIX}.USDAPSD`,
    defaultMessage: "USDA PSD",
  },
  Quarterly: {
    id: `${PREFIX}.Quarterly`,
    defaultMessage: "Quarterly updates",
  },
  By7Month: {
    id: `${PREFIX}.By7Month`,
    defaultMessage: "By the 7th of of Feb, May, Aug & Nov",
  },
  WorldBankFP: {
    id: `${PREFIX}.WorldBankFP`,
    defaultMessage: "World bank forecast prices",
  },
  By10month: {
    id: `${PREFIX}.By10month`,
    defaultMessage: "By the 10th of of Feb, May, Aug & Nov",
  },
  Slide23: {
    id: `${PREFIX}.Slide23`,
    defaultMessage: "Slide 23 - USDA crops and EIA crude oil prices",
  },
  By25month: {
    id: `${PREFIX}.By25month`,
    defaultMessage: "By the 25th of of Feb, May, Aug & Nov",
  },
  GlobalIP: {
    id: `${PREFIX}.GlobalIP`,
    defaultMessage: "Global insight (prices)",
  },
  Biannual: {
    id: `${PREFIX}.Biannual`,
    defaultMessage: "Biannual updates*",
  },
  UpdateTimelineFootnote: {
    id: `${PREFIX}.UpdateTimelineFootnote`,
    defaultMessage:
      "* Update timeline for these sources is rather indicative, since many of them do not have a precise publication calendar or do not follow published calendar.",
  },
  AprOct: {
    id: `${PREFIX}.AprOct`,
    defaultMessage: "April and October",
  },
  FAOProdSTAT: {
    id: `${PREFIX}.FAOProdSTAT`,
    defaultMessage: "FAO ProdSTAT",
  },
  Annual: {
    id: `${PREFIX}.Annual`,
    defaultMessage: "Annual updates",
  },
  USDAProjP: {
    id: `${PREFIX}.USDAProjP`,
    defaultMessage: "USDA projections (prices)",
  },
  FAOFB: {
    id: `${PREFIX}.FAOFB`,
    defaultMessage: "FAO food balance sheet",
  },
  EUROSTAT: {
    id: `${PREFIX}.EUROSTAT`,
    defaultMessage: "EUROSTAT",
  },
  USDAERS: {
    id: `${PREFIX}.USDAERS`,
    defaultMessage: "USDA ERS GDP data",
  },
  FAPRIcrops: {
    id: `${PREFIX}.FAPRIcrops`,
    defaultMessage: "FAPRI (crops)",
  },
  GlobalIC: {
    id: `${PREFIX}.GlobalIC`,
    defaultMessage: "Global insight (crops)",
  },
  USDAFC: {
    id: `${PREFIX}.USDAFC`,
    defaultMessage: "USDA forecasts (crops)",
  },
  USDAComP: {
    id: `${PREFIX}.USDAComP`,
    defaultMessage: "USDA commodity prices",
  },
  FAOPop: {
    id: `${PREFIX}.FAOPop`,
    defaultMessage: "FAO population",
  },
  OECDFAOCrops: {
    id: `${PREFIX}.OECDFAOCrops`,
    defaultMessage: "OECD-FAO (Crops)",
  },
  FAPRI2015: {
    id: `${PREFIX}.FAPRI2015`,
    defaultMessage: "FAPRI 2015 (Prices)",
  },
  Soybean: {
    id: `${PREFIX}.Soybean`,
    defaultMessage: "Soybean",
  },
  Wheat: {
    id: `${PREFIX}.Wheat`,
    defaultMessage: "Wheat",
  },
  Corn: {
    id: `${PREFIX}.Corn`,
    defaultMessage: "Corn",
  },
  Cocoa: {
    id: `${PREFIX}.Cocoa`,
    defaultMessage: "Cocoa",
  },
  Coffee: {
    id: `${PREFIX}.Coffee`,
    defaultMessage: "Coffee",
  },
  Oat: {
    id: `${PREFIX}.Oat`,
    defaultMessage: "Oat",
  },
  RedWheat: {
    id: `${PREFIX}.RedWheat`,
    defaultMessage: "Red Wheat",
  },
  Rice: {
    id: `${PREFIX}.Rice`,
    defaultMessage: "Rough rice",
  },
  SoybeanOil: {
    id: `${PREFIX}.SoybeanOil`,
    defaultMessage: "Soybean oil",
  },
  SoybeanMeal: {
    id: `${PREFIX}.SoybeanMeal`,
    defaultMessage: "Soybean meal",
  },
  Jan: {
    id: `${PREFIX}.Jan`,
    defaultMessage: "January",
  },
  Feb: {
    id: `${PREFIX}.Feb`,
    defaultMessage: "February",
  },
  Mar: {
    id: `${PREFIX}.Mar`,
    defaultMessage: "March",
  },
  Apr: {
    id: `${PREFIX}.Apr`,
    defaultMessage: "April",
  },
  May: {
    id: `${PREFIX}.May`,
    defaultMessage: "May",
  },
  Jun: {
    id: `${PREFIX}.Jun`,
    defaultMessage: "June",
  },
  Jul: {
    id: `${PREFIX}.Jul`,
    defaultMessage: "July",
  },
  Aug: {
    id: `${PREFIX}.Aug`,
    defaultMessage: "August",
  },
  Sep: {
    id: `${PREFIX}.Sep`,
    defaultMessage: "September",
  },
  Oct: {
    id: `${PREFIX}.Oct`,
    defaultMessage: "October",
  },
  Nov: {
    id: `${PREFIX}.Nov`,
    defaultMessage: "November",
  },
  Dec: {
    id: `${PREFIX}.Dec`,
    defaultMessage: "December",
  },
  OECDFAOPrices: {
    id: `${PREFIX}.OECDFAOPrices`,
    defaultMessage: "OECD-FAO (Prices)",
  },
  FAOProdPrices: {
    id: `${PREFIX}.FAOProdPrices`,
    defaultMessage: "FAO producer prices",
  },
  Biennial: {
    id: `${PREFIX}.Biennial`,
    defaultMessage: "Biennial*",
  },
  FAOTradeSTAT: {
    id: `${PREFIX}.FAOTradeSTAT`,
    defaultMessage: "FAO TradeSTAT",
  },
  Overview: {
    id: `${PREFIX}.Overview`,
    defaultMessage: "Overview",
  },
  APOfficialCropsDatasetOverviewP1: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewP1`,
    defaultMessage:
      "The AP official crops dataset contains historical and forecast data on agricultural developments of major crops per country and year. Several datasources\
    have been put together in order to create long time series that will cover historical and forecast data. The data sources used for the creation of the\
    harmonized dataset are the following:",
  },
  APOfficialCropsDatasetOverviewP2: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewP2`,
    defaultMessage: "Historical data: USDA PS&;D, FAO – ProdSTAT, FAO Trade, FAO Food Balance Sheet, FAO population and EUROSTAT",
  },
  APOfficialCropsDatasetOverviewP3: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewP3`,
    defaultMessage: "Forecast data: USDA Forecast, FAPRI and Global Insight",
  },
  APOfficialCropsDatasetOverviewP4: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewP4`,
    defaultMessage: "Specific dimensions of the harmonized dataset AP Official crops are as follows:",
  },
  APOfficialCropsDatasetOverviewLi1: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewLi1`,
    defaultMessage: "Countries/Regions (~250 countries)",
  },
  APOfficialCropsDatasetOverviewLi2: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewLi2`,
    defaultMessage: "Commodities (~90 commodities, each with a set of applicable attributes)",
  },
  APOfficialCropsDatasetOverviewLi3: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewLi3`,
    defaultMessage:
      "Attributes ( 8 attributes like area harvested, imports, production, exports, yield, ending stocks, domestic consumption and consumption per capita which\
      can vary by commodity and country)",
  },
  APOfficialCropsDatasetOverviewLi4: {
    id: `${PREFIX}.APOfficialCropsDataset.OverviewLi4`,
    defaultMessage: "Annual Data (from 1960 till 2030, depending upon country and commodity)",
  },
  DatasetStructure: {
    id: `${PREFIX}.DatasetStructure`,
    defaultMessage: "Dataset Structure",
  },
  APOfficialCropsDatasetDatasetStructureP1: {
    id: `${PREFIX}.APOfficialCropsDataset.DatasetStructureP1`,
    defaultMessage:
      "In order to ensure a consistent and easy-to-use selection of data, the original structure and dictionaries of the datasets have been altered and\
    reorganized based on BASF’s dictionary for countries, commodities and attributes. Moreover, since different datasources provide data in different scales\
    and units of measure, all data have been brought up to the same scale and units.",
  },
  APOfficialCropsDatasetDatasetStructureP2: {
    id: `${PREFIX}.APOfficialCropsDataset.DatasetStructureP2`,
    defaultMessage:
      "Please find attached the mappings between BASF specific crops, countries and attributes list and the different original datasources list:",
  },
  UpdateSchedule: {
    id: `${PREFIX}.UpdateSchedule`,
    defaultMessage: "Update Schedule",
  },
  APOfficialCropsDatasetUpdateScheduleP1: {
    id: `${PREFIX}.APOfficialCropsDataset.UpdateScheduleP1`,
    defaultMessage:
      "The schedule of updates in the AP official crops dataset depends on the update schedule of each data source provider. As a general rule for monthly updates\
    like USDA PS&D the lag between the update in the source and the AgricultureTerminal is about a 3 days while for the bi-annual and annual updates the\
    lag can be one or two months depending on the data volume and the sections to be updated in the AgricultureTerminal.",
  },
  APOfficialCropsDatasetUpdateScheduleP2: {
    id: `${PREFIX}.APOfficialCropsDataset.UpdateScheduleP2`,
    defaultMessage: "Please find attached the Data Availability file for the AP official crops dataset:",
  },
  USDAFullHeader: {
    id: `${PREFIX}.USDA.FullHeader`,
    defaultMessage: "United States department of agriculture </br> production, supply and distribution (PS&D)",
  },
  USDAOverviewP1: {
    id: `${PREFIX}.USDA.OverviewP1`,
    defaultMessage:
      "Widely known as the most commonly used database for international analysis of agricultural commodities, USDA Foreign Agricultural Service's Production,\
    Supply and Distribution (PS&D) online database covers current and historical data on agricultural production, supply and distribution for the United\
    States and key producing and consuming countries. USDA uses country statistics collected by U.S. embassies around the world, international organizations,\
    and other official sources. The data is cleansed and revised based on inputs from FAS, ERS, NASS, and FSA commodity and country analysts. The same figures\
    can be found in monthly and biannual publications such as USDA’s WASDE Reports, WAOB Reports, Foreign Agricultural Commodity Circular series, and the ERS\
    regional situation and outlook reports.",
  },
  USDAOverviewP2: {
    id: `${PREFIX}.USDA.OverviewP2`,
    defaultMessage: "Specific dimensions of this dataset are as follows:",
  },
  USDAOverviewLi1: {
    id: `${PREFIX}.USDA.OverviewLi1`,
    defaultMessage: "Countries/Regions (~250 countries)",
  },
  USDAOverviewLi2: {
    id: `${PREFIX}.USDA.OverviewLi2`,
    defaultMessage: "Commodities (~90 commodities, each with a set of applicable attributes)",
  },
  USDAOverviewLi3: {
    id: `${PREFIX}.USDA.OverviewLi3`,
    defaultMessage:
      "Attributes (~100 attributes, including area harvested, imports, production, exports, and yield, which vary by commodity)",
  },
  USDAOverviewLi4: {
    id: `${PREFIX}.USDA.OverviewLi4`,
    defaultMessage: "Annual Data (from 1960 till 2014, depending upon country and commodity)",
  },
  USDAOverviewP3: {
    id: `${PREFIX}.USDA.OverviewP3`,
    defaultMessage:
      "The PS&D database is revised and updated periodically throughout the year by USDA as new information pertaining to a specific commodity or country\
    becomes available. As a general rule, USDA will not expect revisions in data points more than four years old. Updates are normally available for most\
    commodities on a monthly basis; some commodities, however, might be updated on an annual basis. In particular, grains, oilseeds, and cotton data is\
    normally released and updated for the most significant countries every month; sugar, coffee, and livestock data is updated on a biannual basis;\
    comprehensive tobacco, forest, and fishery data are updated throughout the year after the receipt and revision of annual reports.",
  },
  DailyNASDAQOverviewP1: {
    id: `${PREFIX}.DailyNASDAQ.OverviewP1`,
    defaultMessage:
      "The Nasdaq Stock Market is an American stock exchange specializing in shares of high-tech companies (electronics,\
    software, etc.). One of the main US stock exchanges (along with the NYSE), which has not been a division of NASD\
    since 2006, is controlled by the SEC.",
  },
  DailyNASDAQCommodityColumnTitle: {
    id: `${PREFIX}.DailyNASDAQ.CommodityColumnTitle`,
    defaultMessage: "Commodity",
  },
  DailyNASDAQLinkColumnTitle: {
    id: `${PREFIX}.DailyNASDAQ.LinkColumnTitle`,
    defaultMessage: "Link",
  },
  GlossaryOfAttributes: {
    id: `${PREFIX}.GlossaryOfAttributes`,
    defaultMessage: "Glossary of Attributes",
  },
  USDAGlossaryOfAttributesP1: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP1`,
    defaultMessage: "Please find attached a document with the glossary of attributes and the relations between the used attributes:",
  },
  USDAGlossaryOfAttributesP2: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP2`,
    defaultMessage: "Aggregation is sum of country attributes.",
  },
  USDAGlossaryOfAttributesP3: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP3`,
    defaultMessage: "Examples:",
  },
  USDAGlossaryOfAttributesP4: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP4`,
    defaultMessage: "Production of cereals = SUM (Production of underlying crops)",
  },
  USDAGlossaryOfAttributesP5: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP5`,
    defaultMessage: "Yield = SUM (production for underlying countries) / (area harvested for underlying countries)",
  },
  USDAGlossaryOfAttributesP6: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP6`,
    defaultMessage: "All commodities excepting raw sugar: Stock – to – use = Ending stocks / Domestic Consumption * 100.",
  },
  USDAGlossaryOfAttributesP7: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP7`,
    defaultMessage: "Raw sugar: Stock – to – use = Ending stocks / Total Disappearance * 100",
  },
  USDAGlossaryOfAttributesP8: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP8`,
    defaultMessage:
      "Total Distribution data from USDA PSD are displayed in the portal as Total Use data. It concerns all the selected commodities.",
  },
  USDAGlossaryOfAttributesP9: {
    id: `${PREFIX}.USDA.GlossaryOfAttributesP9`,
    defaultMessage:
      "Dear Agriculture Terminal user, please be aware that the trade figures for EU-27 are the summation of the member states trade figures excluding the\
    intra-trade between member states.",
  },
  DailyNASDAQGlossaryOfAttributesP2: {
    id: `${PREFIX}.DailyNASDAQ.GlossaryOfAttributesP2`,
    defaultMessage:
      "In AP Agriculture Terminal the data of Soybean, Wheat, Corn, Cocoa, Coffee, Oat, Red Wheat, Rough rice, Soybean oil,\
    Soybean meal are considered. Values are provided with daily frequency.",
  },
  CountryAndCommodityStructure: {
    id: `${PREFIX}.CountryAndCommodityStructure`,
    defaultMessage: "Country and Commodity Structure",
  },
  USDACountryAndCommodityStructureP1: {
    id: `${PREFIX}.USDA.CountryAndCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure of the data and documented our changes in\
    an Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data\
    source.",
  },
  USDACountryAndCommodityStructureP2: {
    id: `${PREFIX}.USDA.CountryAndCommodityStructureP2`,
    defaultMessage: "Please find attached mappings between BASF specific countries and crops list and USDA PSD lists.",
  },
  USDAFormulasP1: {
    id: `${PREFIX}.USDA.FormulasP1`,
    defaultMessage: "Please find attached the list of formula specific to USDA PS&D:",
  },
  USDAReleaseSchedulefor2014H: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014H`,
    defaultMessage: "Release Schedule for 2014",
  },
  USDAReleaseSchedulefor2014TC1H: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014TC1H`,
    defaultMessage: "Release Date",
  },
  USDAReleaseSchedulefor2014TC2H: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014TC2H`,
    defaultMessage: "Release Description",
  },
  USDAReleaseSchedulefor2014CottonGrainsOilseeds: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014CottonGrainsOilseeds`,
    defaultMessage: "Cotton, Grains, Oilseeds, and World Agricultural Production Data",
  },
  USDAReleaseSchedulefor2014Cotton: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Cotton`,
    defaultMessage: "Cotton: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014Grains: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Grains`,
    defaultMessage: "Grains: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014Oilseeds: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Oilseeds`,
    defaultMessage: "Oilseeds: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014WorldProduction: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014WorldProduction`,
    defaultMessage: "World Agricultural Production",
  },
  USDAReleaseSchedulefor2014WorldHorticultureCitrus: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014WorldHorticultureCitrus`,
    defaultMessage: "World Horticulture: Production, Supply, and Distribution: Citrus",
  },
  USDAReleaseSchedulefor2014Sugar: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Sugar`,
    defaultMessage: "Sugar: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014Coffee: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Coffee`,
    defaultMessage: "Coffee: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014Dairy: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Dairy`,
    defaultMessage: "Dairy: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014Raisins: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014Raisins`,
    defaultMessage: "Raisins: World Markets and Trade",
  },
  USDAReleaseSchedulefor2014LivestockAndPoultry: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014LivestockAndPoultry`,
    defaultMessage: "Livestock and Poultry: Production Supply and Distribution",
  },
  USDAReleaseSchedulefor2014TreeNuts: {
    id: `${PREFIX}.USDA.ReleaseSchedulefor2014TreeNuts`,
    defaultMessage: "Tree Nuts: Production, Supply and Distribution",
  },
  UNFAOFullHeader: {
    id: `${PREFIX}.UNFAO.FullHeader`,
    defaultMessage: "United nations food and agriculture organization <br /> ProdSTAT database",
  },
  UNFAOOverviewP1: {
    id: `${PREFIX}.UNFAO.OverviewP1`,
    defaultMessage:
      "FAO ProdSTAT is an extensively used agricultural data set. It covers more commodities than USDA PS&D, but the number of attributes per commodity is\
    limited to production, area, yield and seed. UN FAO collects data from various government sources (mostly in the form of national publications and FAO\
    questionnaires), as well as international agencies. Alternative sources are also used to supplement official statistics in cases where country statistics\
    are not available. FAO releases data pertaining to a country and a particular commodity only after reports arrive, and it generally does not cover any\
    forecast information.FAO Statistics are used in publications such as FAO Statistical Yearbook, which is an official source of global agricultural data.",
  },
  UNFAOOverviewP2: {
    id: `${PREFIX}.UNFAO.OverviewP2`,
    defaultMessage: "Specific dimensions of this dataset are as follows:",
  },
  UNFAOOverviewLi1: {
    id: `${PREFIX}.UNFAO.OverviewLi1`,
    defaultMessage: "Countries/Regions (~200 countries and regions)",
  },
  UNFAOOverviewLi2: {
    id: `${PREFIX}.UNFAO.OverviewLi2`,
    defaultMessage: "Commodities (~220 crops and livestock primary and processed commodities, each with a set of applicable subjects)",
  },
  UNFAOOverviewLi3: {
    id: `${PREFIX}.UNFAO.OverviewLi3`,
    defaultMessage: "Subjects (relating to production quantity, area/stock, yield and seed, varying by commodity)",
  },
  UNFAOOverviewLi4: {
    id: `${PREFIX}.UNFAO.OverviewLi4`,
    defaultMessage: "Annual statistics ( from 1961 to 2012, depending on country and by commodity)",
  },
  UNFAOGlossaryOfAttributesP1: {
    id: `${PREFIX}.UNFAO.GlossaryOfAttributesP1`,
    defaultMessage: "Please find attached the definitions on used attributes:",
  },
  UNFAOGlossaryOfAttributesP2: {
    id: `${PREFIX}.UNFAO.GlossaryOfAttributesP2`,
    defaultMessage: "Aggregation is sum of country attributes.",
  },
  UNFAOGlossaryOfAttributesP3: {
    id: `${PREFIX}.UNFAO.GlossaryOfAttributesP3`,
    defaultMessage: "Examples:",
  },
  UNFAOGlossaryOfAttributesP4: {
    id: `${PREFIX}.UNFAO.GlossaryOfAttributesP4`,
    defaultMessage: "Production of cereals = SUM (Production of underlying crops)",
  },
  UNFAOGlossaryOfAttributesP5: {
    id: `${PREFIX}.UNFAO.GlossaryOfAttributesP5`,
    defaultMessage: "Yield = SUM (production for underlying countries) / (area harvested for underlying countries)",
  },
  UNFAOCountryAndCommodityStructureP1: {
    id: `${PREFIX}.UNFAO.CountryAndCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure the data and documented our changes in an\
    Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data source.",
  },
  ReleaseSchedule: {
    id: `${PREFIX}.ReleaseSchedule`,
    defaultMessage: "Release Schedule",
  },
  UNFAOReleaseScheduleP1: {
    id: `${PREFIX}.UNFAO.ReleaseScheduleP1`,
    defaultMessage:
      "The ProdSTAT database is a set of data that is revised and updated by UN FAO bi-annually. For detailed release, please visit FAOStat Release Calendar site:",
  },
  UNFAOReleaseScheduleP2: {
    id: `${PREFIX}.UNFAO.ReleaseScheduleP2`,
    defaultMessage: "For additional information, please visit FAO's statistical concepts, definitions and classifications site:",
  },
  DailyNASDAQReleaseScheduleP3: {
    id: `${PREFIX}. DailyNASDAQ.ReleaseScheduleP3`,
    defaultMessage: "Commodity prices are provided at the end of each trading day.",
  },
  UNFAOFormulasP1: {
    id: `${PREFIX}.UNFAO.FormulasP1`,
    defaultMessage: "Please find attached the list of formula specific to FAO Prodstat:",
  },
  FAOFullHeader: {
    id: `${PREFIX}.FAO.FullHeader`,
    defaultMessage: "FAO-OECD agricultural outlook",
  },
  FAOOverviewP1: {
    id: `${PREFIX}.FAO.OverviewP1`,
    defaultMessage:
      "The Agricultural Outlook database is used and generated by collaborative work between the Organization for Economic Co-operation and Development (OECD) and\
    the United Nation’s Food and Agricultural Organization (FAO) in the field of agricultural market outlook. The report analyses world commodity market trends\
    and medium term prospects for the main agricultural products over a 10 years horizon. It shows how these markets are influenced by economic developments\
    and government policies and highlights some of the risks and uncertainties that may influence market outcomes.",
  },
  FAOOverviewP2: {
    id: `${PREFIX}.FAO.OverviewP2`,
    defaultMessage:
      "The main tool in the OECD-FAO agricultural outlook process is a partial modeling framework. This effort was started by the OECD in the early 1990s through\
    the development of its AGLINK model, an economic model of world agriculture with very detailed agricultural sector representation of OECD countries as well\
    as Argentina, Brazil, China and Russia. The AGLINK-COSIMO modeling system is presently one of the most comprehensive partial equilibrium models for global\
    agriculture. The model is one of the tools used in the generation of baseline projections underlying the OECD-FAO Agricultural Outlook.",
  },
  FAOOverviewP3: {
    id: `${PREFIX}.FAO.OverviewP3`,
    defaultMessage: "Specific dimensions of this dataset are as follows:",
  },
  FAOOverviewLi1: {
    id: `${PREFIX}.FAO.OverviewLi1`,
    defaultMessage: "Commodities (~15major crops; forecast data might vary by commodity)",
  },
  FAOOverviewLi2: {
    id: `${PREFIX}.FAO.OverviewLi2`,
    defaultMessage: "Items (~12 items relating to area, prices, supply and use, yield, varying by commodity)",
  },
  FAOOverviewLi3: {
    id: `${PREFIX}.FAO.OverviewLi3`,
    defaultMessage: "Annual Forecasts (1970–2022, varying by country and by commodity)",
  },
  FAOGlossaryOfAttributesP1: {
    id: `${PREFIX}.FAO.GlossaryOfAttributesP1`,
    defaultMessage: "Please find attached definitions on used attributes:",
  },
  FAOCountryAndCommodityStructureP1: {
    id: `${PREFIX}.FAO.CountryAndCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure of the data and documented our changes in\
    an Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data\
    source.",
  },
  FAOReleaseScheduleP1: {
    id: `${PREFIX}.FAO.ReleaseScheduleP1`,
    defaultMessage:
      "The OECD-FAO database is a set of data that is revised and updated on an annual basis. OECD-FAO does not maintain a release schedule.",
  },
  FAOFormulasP1: {
    id: `${PREFIX}.FAO.FormulasP1`,
    defaultMessage: "Please find attached the list of formula specific to OECD-FAO:",
  },
  FAPRIFullHeader: {
    id: `${PREFIX}.FAPRI.FullHeader`,
    defaultMessage: "The food and agricultural policy research institute (FAPRI) <br /> World agricultural outlook database",
  },
  FAPRIOverviewP1: {
    id: `${PREFIX}.FAPRI.OverviewP1`,
    defaultMessage:
      "The food and agricultural policy research institute (FAPRI) is a dual-university research effort that uses comprehensive data to provide trade and\
    agricultural analysis. Their annual agricultural outlook database covers baseline projections till 2025 for the U.S. and international agricultural\
    sectors. The main commodities covered are: wheat, rice, coarse grains, oilseeds, cotton, sugar, biofuels, livestock, and dairy products. For more details\
    on the assumptions, please check the below document.",
  },
  FAPRIOverviewP2: {
    id: `${PREFIX}.FAPRI.OverviewP2`,
    defaultMessage: "The dataset covers the following dimensions:",
  },
  FAPRIOverviewLi1: {
    id: `${PREFIX}.FAPRI.OverviewLi1`,
    defaultMessage: "Commodities (~150 commodities available, forecast data might vary by commodity)",
  },
  FAPRIOverviewLi2: {
    id: `${PREFIX}.FAPRI.OverviewLi2`,
    defaultMessage: "Items (~ 100 attributes related to supply & use, production and yield, vary by commodity)",
  },
  FAPRIOverviewLi3: {
    id: `${PREFIX}.FAPRI.OverviewLi3`,
    defaultMessage: "Annual Forecasts (2010-2021, vary by country and by commodity)",
  },
  FAPRIOverviewP3: {
    id: `${PREFIX}.FAPRI.OverviewP3`,
    defaultMessage:
      "Please be aware that Net Trade = Exports – Imports. Positive values imply that a country is net exporter and negative values imply that a country is net\
    importer.",
  },
  FAPRIGlossaryOfAttributesP1: {
    id: `${PREFIX}.FAPRI.GlossaryOfAttributesP1`,
    defaultMessage: "Please find attached a document with the glossary of attributes and the relations between the used attribute:",
  },
  FAPRICountryAndCommodityStructureP1: {
    id: `${PREFIX}.FAPRI.CountryAndCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure of the data and documented our changes in\
    an Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data\
    source.",
  },
  FAPRICountryAndCommodityStructureP2: {
    id: `${PREFIX}.FAPRI.CountryAndCommodityStructureP2`,
    defaultMessage:
      "Please be aware that for some country groups such as Other Latin America or Rest of World, the number of countries per group can differ from commodity to\
    commodity because the source publishes data in different ways for different commodities.",
  },
  FAPRIReleaseScheduleP1: {
    id: `${PREFIX}.FAPRI.ReleaseScheduleP1`,
    defaultMessage: "The data are updated on an annual basis. FAPRI does not maintain a release schedule.",
  },
  FAPRIFormulasP1: {
    id: `${PREFIX}.FAPRI.FormulasP1`,
    defaultMessage: "Please find attached the list of formula specific to FAPRI:",
  },
  USDACropFullHeader: {
    id: `${PREFIX}.USDACrop.FullHeader`,
    defaultMessage: "United States department of agriculture - crop forecasts (agricultural projection)",
  },
  USDACropSubtitle1: {
    id: `${PREFIX}.USDACrop.Subtitle1`,
    defaultMessage: "US forecast:",
  },
  USDACropSubtitle2: {
    id: `${PREFIX}.USDACrop.Subtitle2`,
    defaultMessage: "Non US countries:",
  },
  USDACropOverviewP1: {
    id: `${PREFIX}.USDACrop.OverviewP1`,
    defaultMessage:
      "USDA offers long-run (10-year) projections for the U.S. agricultural sector. Major commodities, including corn, sorghum, barley, oats, wheat, soybean,\
    rice, upland cotton, sugar, horticultural crops, livestock, and dairy as well as retail food prices and food expenditures for the United States are made\
    available by USDA for the U.S. market. Foreign trade projections for a limited number of countries are also available on coarse grains, corn trade,\
    sorghum, barley, wheat, soybean, rice, cotton, beef, pork, and poultry. The forecast is based on specific assumptions regarding macroeconomic conditions\
    and agricultural and trade policies as well as agricultural production growth over time. The results are reviewed by the World Agricultural Outlook Board,\
    the Economic Research Service, the Farm Service Agency, the Foreign Agricultural Service, the Agricultural Marketing Service, the Office of the Chief\
    Economist, the Office of Budget and Program Analysis, the Risk Management Agency, the Natural Resources Conservation Service, and the Cooperative State\
    Research, Education, and Extension Service. For more details on the assumptions, please check the below document.",
  },
  USDACropOverviewP2: {
    id: `${PREFIX}.USDACrop.OverviewP2`,
    defaultMessage: "The latest projections, released May 2013, cover the following dimensions:",
  },
  USDACropOverviewLi1: {
    id: `${PREFIX}.USDACrop.OverviewLi1`,
    defaultMessage: "Commodities (major crops and limited livestock commodities available; forecast data might vary by commodity)",
  },
  USDACropOverviewLi2: {
    id: `${PREFIX}.USDACrop.OverviewLi2`,
    defaultMessage:
      "Items (~30 items relating to area, prices, returns over variable costs, supply and use, variable costs of production, and yield, varying by commodity)",
  },
  USDACropOverviewLi3: {
    id: `${PREFIX}.USDACrop.OverviewLi3`,
    defaultMessage: "Annual Forecasts (2011 – 2022, varying by country and by commodity)",
  },
  USDACropGlossaryOfAttributesP1: {
    id: `${PREFIX}.USDACrop.GlossaryOfAttributesP1`,
    defaultMessage: "Please find in the attached document, the glossary of attributes:",
  },
  USDACropCountryandCommodityStructureP1: {
    id: `${PREFIX}.USDACrop.CountryandCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure of the data and documented our changes in\
    an Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data\
    source.",
  },
  USDACropReleaseScheduleP1: {
    id: `${PREFIX}.USDACrop.ReleaseScheduleP1`,
    defaultMessage: "The data are updated on an annual basis. USDA does not maintain a release schedule for this database.",
  },
  USDACropFormulasP1: {
    id: `${PREFIX}.USDACrop.FormulasP1`,
    defaultMessage: "Please find attached the list of formula specific to USDA Forecasts:",
  },
  APPricesOverviewP1: {
    id: `${PREFIX}.APPrices.OverviewP1`,
    defaultMessage:
      "The AP Official Absolute Prices and Price Indices datasets contains data about prices and indices, both agriculture- and non-agriculture-related, from\
    sources such as USDA commodity prices, ICE Global Markets Futures, NYSE Liffe Futures and World Bank Prices.",
  },
  APPricesDatasetStructureP1: {
    id: `${PREFIX}.APPrices.DatasetStructureP1`,
    defaultMessage:
      "In order to ensure a consistent and easy-to-use selection of data, the original structure and dictionaries of the datasets have been altered and\
    reorganized based on BASF’s dictionary for commodities and attributes. Moreover, since different datasources provide data in different scales and units of\
    measure, all data have been brought up to the same scale and units.",
  },
  APPricesDatasetStructureP2: {
    id: `${PREFIX}.APPrices.DatasetStructureP2`,
    defaultMessage: "Please find attached the mappings between BASF specific commodity prices and the different original datasources list:",
  },
  APPricesFieldCropsH: {
    id: `${PREFIX}.APPrices.FieldCropsH`,
    defaultMessage: "Field Crops",
  },
  USDAAMSMarketNews: {
    id: `${PREFIX}.USDAAMSMarketNews`,
    defaultMessage: "USDA AMS Market News",
  },
  USDAAMSMarketNewsP1: {
    id: `${PREFIX}.USDAAMSMarketNewsP1`,
    defaultMessage:
      "USDA AMS provides domestic and international market news reports. These reports include information on prices, volume, quality, condition, and other market\
    data on farm products in specific markets and marketing areas.",
  },
  USDAAMSMarketNewsP2: {
    id: `${PREFIX}.APPrices.USDAAMSMarketNewsP2`,
    defaultMessage:
      "The commodity prices from the reports <a target='_blank' class='HelpPage-Link' href='http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateN&amp;navID=MarketNewsAndTransportationData&amp;leftNav=MarketNewsAndTransportationData&amp;page=NationalGrainReports'>\
      Daily Grain Review\
      </a> and <a target='_blank' class='HelpPage-Link' href='http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateG&amp;navID=CNMarketNewsReports&amp;rightNav1=CNMarketNewsReports&amp;topNav=&amp;leftNav=CommodityAreas&amp;page=CNMNPublications&amp;resultType=&amp;acct=cgeninfo'>\
      Weekly Cotton Market Review\
      </a> are shown in the AP Official Commodity Prices section of the Terminal. These prices are <em><u>Gulf Corn</u>, <u>Gulf Soybeans</u>, <u>Gulf Hard Red Winter Wheat</u>, </em>and<em> <u>Adjusted World Cotton prices</u></em> and updated weekly",
  },
  APPricesUSDAGAINH: {
    id: `${PREFIX}.APPrices.USDAGAINH`,
    defaultMessage: "USDA Global Agricultural Information Network (GAIN)",
  },
  APPricesUSDAGAINP1: {
    id: `${PREFIX}.APPrices.USDAGAINP1`,
    defaultMessage:
      "USDA'S Global Agriculture Information Network (GAIN) provides timely information on the agricultural economy, products and issues in foreign countries\
    since 1995 that are likely to have an impact on United States agricultural production and trade. U.S. Foreign Service officers working at posts overseas\
    collect and submit information on the agricultural situation in more than 130 countries to USDA's Foreign Agricultural Service (FAS), which maintains the\
    GAIN reports.",
  },
  APPricesUSDAGAINP2: {
    id: `${PREFIX}.APPrices.USDAGAINP2`,
    defaultMessage:
      "Thai Rice Prices (FOB) from the report <a target='_blank' class='HelpPage-Link' href='http://gain.fas.usda.gov/Recent%20GAIN%20Publications/Forms/AllItems.aspx'>Rice Price - Weekly_Bangkok_Thailand</a> are shown in the AP Official Commodity Prices section of the Terminal and updated weekly.",
  },
  APPricesICEH: {
    id: `${PREFIX}.APPrices.ICEH`,
    defaultMessage: "ICE Global Markets in Clear View",
  },
  APPricesICEP1: {
    id: `${PREFIX}.APPrices.ICEP1`,
    defaultMessage:
      "IntercontinentalExchange (ICE) provides Futures, Options and OTC swaps contracts for the world's most heavily traded commodities.\
    Sugar No. 11 Nearby Futures Settlement Prices from the <a target='_blank' class='HelpPage-Link' href='https://www.theice.com/productguide/ProductSpec.shtml?specId=23'>ICE End of Day Reports</a> are shown in the AP Official Commodity Prices section of the Terminal and updated weekly.",
  },
  APPricesNYSEH: {
    id: `${PREFIX}.APPrices.NYSEH`,
    defaultMessage: "NYSE EURONEXT Global Derivatives – NYSE Liffe",
  },
  APPricesNYSEP1: {
    id: `${PREFIX}.APPrices.NYSEP1`,
    defaultMessage:
      "NYSE Liffe lists a broad range of futures and options contracts on commodities. These contracts offer an effective and efficient tool for hedging the price\
    risk as well as a vehicle for trading, investment and arbitrage activity.",
  },
  APPricesNYSEP2: {
    id: `${PREFIX}.APPrices.NYSEP2`,
    defaultMessage:
      "Rapeseed Nearby Futures Settlement Prices from the <a target='_blank' class='HelpPage-Link' href='https://globalderivatives.nyx.com/en/contract/content/29826/settlement-prices'>Liffe Rapeseed Futures Contracts</a> are shown in the AP Official Commodity Prices section of the Terminal and updated weekly.",
  },
  APPricesFertilizerPricesH: {
    id: `${PREFIX}.APPrices.FertilizerPricesH`,
    defaultMessage: "Fertilizer Prices",
  },
  APPricesFertilizerUSDAAMSP2: {
    id: `${PREFIX}.APPrices.FertilizerUSDAAMSP2`,
    defaultMessage:
      "The commodity prices from the reports <a target='_blank' class='HelpPage-Link' href='http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateP&amp;navID=MarketNewsAndTransportationData&amp;leftNav=MarketNewsAndTransportationData&amp;page=LSMarketNewsPageFeedstuffs'>\
      Alabama Weekly Feedstuff/Production Cost report (Mon)\
      </a> and <a target='_blank' class='HelpPage-Link' href='http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateP&amp;navID=MarketNewsAndTransportationData&amp;leftNav=MarketNewsAndTransportationData&amp;page=LSMarketNewsPageFeedstuffs'>\
      Iowa Production Cost (Bi-weekly)\
    </a> and are shown in the AP Official Commodity Prices section of the AgricultureTerminal. These prices are\
    Ammonium Nitrate (updated weekly) and Anhydrous Ammonia (updated bi-weekly).",
  },
  APPricesFertilizerWorldBankH: {
    id: `${PREFIX}.APPrices.FertilizerWorldBankH`,
    defaultMessage: "The World Bank",
  },
  APPricesFertilizerWorldBankP1: {
    id: `${PREFIX}.APPrices.FertilizerWorldBankP1`,
    defaultMessage:
      "The World Bank provides Market prices and Indices for 70 products which are updated on a monthly basis. Moreover, it publishes on a quarterly basis price\
    forecasts for the next 10 years.",
  },
  APPricesFertilizerWorldBankP2: {
    id: `${PREFIX}.APPrices.FertilizerWorldBankP2`,
    defaultMessage:
      "The commodity prices from the <a target='_blank' class='HelpPage-Link' href='http://econ.worldbank.org/WBSITE/EXTERNAL/EXTDEC/EXTDECPROSPECTS/0,,contentMDK:21574907~menuPK:7859231~pagePK:64165401~piPK:64165026~theSitePK:476883,00.html'>\
      Prices (Pink Sheet)\
    </a> are shown in the AP Official Commodity Prices section of the Terminal. These prices are DAP,\
    Potassium chloride and Urea, E. Europe and updated monthly.",
  },
  APForecastOverviewP1: {
    id: `${PREFIX}.APForecast.OverviewP1`,
    defaultMessage:
      "The AP Official Forecast Prices section contains agriculture-related forecast prices from sources such as USDA Projections, FAPRI, WorldBank and OECD FAO.",
  },
  APForecastDatasetStructureP1: {
    id: `${PREFIX}.APForecast.DatasetStructureP1`,
    defaultMessage:
      "In order to ensure a consistent and easy-to-use selection of data, the original structure and dictionaries of the datasets have been altered and\
    reorganized based on BASF’s dictionary for commodity prices. Moreover, since different datasources provide data in different scales and units of measure,\
    all data have been brought up to the same scale and units.",
  },
  APForecastDatasetStructureP2: {
    id: `${PREFIX}.APForecast.DatasetStructureP2`,
    defaultMessage:
      " Please find attached the mappings between BASF specific commodity prices and the different original datasources list:",
  },
  APForecastDatasetStructureP3: {
    id: `${PREFIX}.APForecast.DatasetStructureP3`,
    defaultMessage: "USDA Economics, Statistics, and Market Information System",
  },
  APForecastDatasetStructureP4: {
    id: `${PREFIX}.APForecast.DatasetStructureP4`,
    defaultMessage:
      "USDA Agricultural Projections provide longrun projections for the farm sector for the next 10 years. These annual projections cover agricultural\
    commodities, agricultural trade, and aggregate indicators of the sector, such as farm income and food prices.",
  },
  APForecastDatasetStructureP5: {
    id: `${PREFIX}.APForecast.DatasetStructureP5`,
    defaultMessage: "FAPRI-ISU World Agricultural Outlook",
  },
  APForecastDatasetStructureP6: {
    id: `${PREFIX}.APForecast.DatasetStructureP6`,
    defaultMessage:
      "Published by the Food and Agricultural Policy Research Institute with centers at Iowa State University, Ames, and the University of Missouri, Columbia.\
    This publication contains recent baseline projections from the food and agricultural policy research institute (FAPRI) for the U.S. agricultural sector and\
    international commodity markets. These projections serve as a baseline for evaluating and comparing alternative macroeconomic, policy, weather, and\
    technological scenarios.",
  },
  APForecastDatasetStructureP7: {
    id: `${PREFIX}.APForecast.DatasetStructureP7`,
    defaultMessage: "WORLD BANK Commodity Markets",
  },
  APForecastDatasetStructureP8: {
    id: `${PREFIX}.APForecast.DatasetStructureP8`,
    defaultMessage:
      "The World Bank monitors major commodity markets important to the developing countries. Price forecasts for the next 10 years are published on a quarterly\
    basis.",
  },
  APForecastDatasetStructureP9: {
    id: `${PREFIX}.APForecast.DatasetStructureP9`,
    defaultMessage: "OECD FAO Agricultural Outlook",
  },
  APForecastDatasetStructureP10: {
    id: `${PREFIX}.APForecast.DatasetStructureP10`,
    defaultMessage:
      "The Agricultural Outlook has been prepared as a joint report by the Organisation for Economic Co-operation and Development (OECD) and the Food and\
    Agriculture Organization (FAO) of the United Nations- The report provides a ten year forward looking, assessment of trends and prospects in the major\
    temperate-zone agricultural commodity markets- It is published annually, in the middle of the second quarter, as part of a continuing effort to promote\
    informed discussion of emerging market and policy issues- The projections and assessments provided in the report are the result of close co-operation\
    between the OECD and FAO Secretariats and national experts with a jointly developed modelling system, based on the AGLINK-COSIMO model, used to facilitate\
    consistency in the projections- The data series for the projections are drawn from OECD and FAO databases- For the most part information in these databases\
    has been taken from national statistical sources.",
  },
  AlternativePriceOverviewP1: {
    id: `${PREFIX}.AlternativePrice.OverviewP1`,
    defaultMessage:
      "The Alternative Price Sources section contains data about prices, both agriculture- and non-agriculture-related, from sources such as FAO International\
    Commodity Prices, IMF Prices, and US Farm Prices.",
  },
  AlternativePriceIMFPrimaryH: {
    id: `${PREFIX}.AlternativePrice.IMFPrimaryH`,
    defaultMessage: "IMF Primary Commodity Prices",
  },
  AlternativePriceCbotH: {
    id: `${PREFIX}.AlternativePrice.CbotH`,
    defaultMessage: "CBOT Prices",
  },
  AlternativePriceCbotOverview: {
    id: `${PREFIX}.AlternativePrice.CbotOverview`,
    defaultMessage:
      "CBOT exchange (along with four other markets - CME, NYMEX, COMEX and KCBOT) is a part of CME Group, one of the world’s leading and most diverse derivatives marketplace. Daily settlement reports contain statistics for every commodity futures contract that is eligible for trade on a particular maturity trade date.",
  },
  AlternativePriceCbotGlossaryP1: {
    id: `${PREFIX}.AlternativePrice.CbotGlossaryP1`,
    defaultMessage:
      "In AP Agriculture Terminal only the data of Corn, Rough Rice, Soybeans and KC Hard Red Winter Wheat are considered. More specifically, source data refers to <b>futures settlement prices</b>, which is the price calculated at the end of the trading day for the corresponding contract. ",
  },
  AlternativePriceCbotGlossaryP2: {
    id: `${PREFIX}.AlternativePrice.CbotGlossaryP2`,
    defaultMessage:
      "Values are provided with weekly frequency and they can be queried via CBOT Prices dataset in Bulk Export section by exact contract expiry month. Another use of CBOT prices in the application is the calculation of short-term forecast prices by simply averaging settlement prices of commodity futures’ contracts expiring in particular year. Such data can retrieved within AP Official Forecast Prices dataset.",
  },
  AlternativePriceCbotReleaseP1: {
    id: `${PREFIX}.AlternativePrice.CbotReleaseP1`,
    defaultMessage:
      "Commodity settlement prices are provided at the end of each trading day, but in AP Agriculture Terminal only Wednesday prices are considered and they are being updated in the week after their publication.",
  },
  AlternativePriceCftH: {
    id: `${PREFIX}.AlternativePrice.CftH`,
    defaultMessage: "CFTC Trader data for Futures",
  },
  AlternativePriceCftOverviewP1: {
    id: `${PREFIX}.AlternativePrice.CftOverviewP1`,
    defaultMessage:
      "Data is being collected and updated on weekly basis from the Futures-and-Options Combined Reports that are part of the Commitments of Traders (COT) reports. These reports provide a breakdown of each Tuesday's open interest for markets in which 20 or more traders hold positions equal to or above the reporting levels established by the CFTC.",
  },
  AlternativePriceCftOverviewP2: {
    id: `${PREFIX}.AlternativePrice.CftOverviewP2`,
    defaultMessage:
      "Data can is available all the way back to 1998. The original frequency of data is weekly, but monthly, quarterly and annual aggregates are calculated as well.",
  },
  AlternativePriceCftOverviewP3: {
    id: `${PREFIX}.AlternativePrice.CftOverviewP3`,
    defaultMessage:
      "Reports are available in both a short and long format. The short report shows open interest separately by reportable and non-reportable positions. For reportable positions, additional data is provided for commercial and non-commercial holdings, spreading, changes from the previous report, percents of open interest by category, and numbers of traders. The long report, in addition to the information in the short report, also groups the data by crop year, where appropriate, and shows the concentration of positions held by the largest four and eight traders. The Supplemental report is published since 2006 for Futures-and-Options-Combined in selected agricultural markets and, in addition to showing all the information in the short format, shows positions of Index Traders.",
  },
  AlternativePriceCftGlossaryP1: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP1`,
    defaultMessage:
      "In the AP Agriculture Terminal, data is available only for Corn, Soybean and Wheat commodities. Only the specific attributes of interest were included in the application. Sometimes the same indicator is used in calculation of more than one aggregate, in order to create aggregates by traders’ position (long vs. short) and classification (commercial vs. non-commercial positions). In addition, here are some notions from the source that help understand the metadata.",
  },
  AlternativePriceCftGlossaryP2: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP2`,
    defaultMessage: `<b>Open interest</b> is the total of all futures and/or option contracts entered into and not yet offset by a transaction, by delivery, by exercise, etc. The aggregate of all long open interest is equal to the aggregate of all short open interest. Open interest held or controlled by a trader is referred to as that trader's position. For the COT Futures-and-Options-Combined report, option open interest and traders' option positions are computed on a futures-equivalent basis using delta factors supplied by the exchanges. Long-call and short-put open interest are converted to long futures-equivalent open interest. Likewise, short-call and long-put open interest are converted to short futures-equivalent open interest. A trader's long and short futures-equivalent positions are added to the trader's long and short futures positions to give "combined-long" and "combined-short" positions. Open interest does not include open futures contracts against which notices of deliveries have been stopped by a trader or issued by the clearing organization of an exchange.`,
  },
  AlternativePriceCftGlossaryP3: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP3`,
    defaultMessage:
      "<b>Commercial</b> and <b>Non-commercial traders</b> concern all individual reportable traders that are identified to the Commission. All of a trader's reported futures positions in a commodity are classified as commercial if the trader uses futures contracts in that particular commodity for hedging as defined in CFTC regulations. A trader may be classified as a commercial trader in some commodities and as a non-commercial trader in other commodities. A single trading entity cannot be classified as both a commercial and non-commercial trader in the same commodity. Nonetheless, a multi-functional organization that has more than one trading entity may have each trading entity classified separately in a commodity. For example, a financial organization trading in financial futures may have a banking entity whose positions are classified as commercial and have a separate money-management entity whose positions are classified as non-commercial.",
  },
  AlternativePriceCftGlossaryP4: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP4`,
    defaultMessage:
      "For the options-and-futures-combined report, <b>spreading</b> measures the extent to which each non-commercial trader holds equal combined-long and combined-short positions. These figures do not include intermarket spreading, such as spreading Eurodollar futures against Treasury Note futures. ",
  },
  AlternativePriceCftGlossaryP5: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP5`,
    defaultMessage:
      "To determine the total <b>number of traders</b> in a market, a trader is counted only once whether or not the trader appears in more than one category (non-commercial traders may be long or short only and may be spreading, while commercial traders may be long and short). To determine the number of traders in each category, however, a trader is counted in each category in which the trader holds a position. The sum of the numbers of traders in each category, therefore, will often exceed the number of traders in that market. ",
  },
  AlternativePriceCftReleaseP1: {
    id: `${PREFIX}.AlternativePrice.CftGlossaryP5`,
    defaultMessage:
      "Futures-and-Options Combined Reports are published every Friday at 3:30 p.m. EST and the updated data is available in the AP Agriculture Terminal by the following Wednesday.",
  },
  AlternativePriceIMFPrimaryLi1: {
    id: `${PREFIX}.AlternativePrice.IMFPrimaryLi1`,
    defaultMessage: "8 price indices and 49 actual price series",
  },
  AlternativePriceIMFPrimaryLi2: {
    id: `${PREFIX}.AlternativePrice.IMFPrimaryLi2`,
    defaultMessage: "Monthly data (1980–current), quarterly and annual averages varying by commodity prices",
  },
  AlternativePriceIMFPrimaryP1: {
    id: `${PREFIX}.AlternativePrice.IMFPrimaryP1`,
    defaultMessage:
      "Dear Agriculture Terminal user, IMF no longer updates the following two prices “Sorghum; U.S., Number 2 yellow, fob Gulf of Mexico” and “Crude Oil\
    (petroleum), Price index, simple average of three spot prices; Dated Brent, West Texas Intermediate, and the Dubai Fateh”.",
  },
  AlternativePriceFAOIntH: {
    id: `${PREFIX}.AlternativePrice.FAOIntH`,
    defaultMessage: "FAO international commodity prices",
  },
  AlternativePriceFAOIntLi1: {
    id: `${PREFIX}.AlternativePrice.FAOIntLi1`,
    defaultMessage: "~30 actual price series and ~30 actual monthly price series",
  },
  AlternativePriceFAOIntLi2: {
    id: `${PREFIX}.AlternativePrice.FAOIntLi2`,
    defaultMessage: "Weekly and monthly data (1987–current), with calculated averages varying by commodity prices",
  },
  AlternativePriceUSFarmH: {
    id: `${PREFIX}.AlternativePrice.USFarmH`,
    defaultMessage: "U.S. Farm Prices for Selected Fertilizers (United States)",
  },
  AlternativePriceUSFarmLi1: {
    id: `${PREFIX}.AlternativePrice.USFarmLi1`,
    defaultMessage: "~3 wholesale fertilizer price indices (1960–2011, annual)",
  },
  AlternativePriceUSFarmLi2: {
    id: `${PREFIX}.AlternativePrice.USFarmLi2`,
    defaultMessage: "~9 average fertilizer farm prices (1960–2011, monthly; though most years have less than two recorded data points)",
  },
  APTradeFullHeader: {
    id: `${PREFIX}.APTrade.FullHeader`,
    defaultMessage: "AP official trade flow dataset - UN comtrade",
  },
  APTradeP1: {
    id: `${PREFIX}.APTrade.P1`,
    defaultMessage:
      "The UN COMTRADE database can be used for monitoring and analyzing agricultural commodity trade flows among most countries. Users can work with data in up\
    to six dimensions through any choice of",
  },
  APTradeLi1: {
    id: `${PREFIX}.APTrade.Li1`,
    defaultMessage: "Reporting Country/Region (~250 countries)",
  },
  APTradeLi2: {
    id: `${PREFIX}.APTrade.Li2`,
    defaultMessage: "Destination Country/Region (~300 countries or other areas)",
  },
  APTradeLi3: {
    id: `${PREFIX}.APTrade.Li3`,
    defaultMessage: "Flow (exports/imports; re-exports/re-imports, trade balance/total trade)",
  },
  APTradeLi4: {
    id: `${PREFIX}.APTrade.Li4`,
    defaultMessage: "Commodity (~5000 commodities at the HS 6-digit level)",
  },
  APTradeLi5: {
    id: `${PREFIX}.APTrade.Li5`,
    defaultMessage: "Measure (value, weight, quantity, or unit price)",
  },
  APTradeLi6: {
    id: `${PREFIX}.APTrade.Li6`,
    defaultMessage: "Annual data (dating as far back as 1962, depending on country and commodity)",
  },
  APTradeP2: {
    id: `${PREFIX}.APTrade.P2`,
    defaultMessage:
      "COMTRADE Statistics is published and maintained by the UN, using data sources such as individual country statistics as well as data from partner\
    organizations such as IMF, FAO, and OECD.",
  },
  APTradeGlossaryOfAttributesP1: {
    id: `${PREFIX}.APTrade.GlossaryOfAttributesP1`,
    defaultMessage: "Please find attached a document with the glossary of attributes and the relations between the used attribute:",
  },
  APTradeCountryandCommodityStructureP1: {
    id: `${PREFIX}.APTrade.CountryandCommodityStructureP1`,
    defaultMessage:
      "To ensure a consistent and easy-to-use selection of countries and commodities, we altered the original structure of the data and documented our changes in\
    an Excel spreadsheet. Please see this spreadsheet to review how data are aggregated for the purposes of Agriculture Terminal with regard to this data\
    source.",
  },
  APTradeReleaseScheduleP1: {
    id: `${PREFIX}.APTrade.ReleaseScheduleP1`,
    defaultMessage:
      "The data are updated periodically throughout the year, but UN Comtrade does not maintain a data release schedule. ProduceTracker will be updated on monthly\
    basis.",
  },
  MacroeconomyGdpDataH: {
    id: `${PREFIX}.Macroeconomy.GdpDataH`,
    defaultMessage: "Real GDP data from USDA Economic Research Service",
  },
  MacroeconomyOverviewP1: {
    id: `${PREFIX}.Macroeconomy.OverviewP1`,
    defaultMessage:
      "USDA ERS dataset provides historical and projected annual data for real gross domestic product (GDP) and some other macroeconomic indicators for 189 countries, 37 regional aggregates and 12 income-based aggregates of the world economy.",
  },
  MacroeconomyGlossaryP1: {
    id: `${PREFIX}.Macroeconomy.GlossaryP1`,
    defaultMessage:
      "Being measured in constant 2010 dollars, real GDP is an appropriate measure for understanding differences across countries and changes over time in national purchasing capacity.  Measuring GDP in constant (real) value terms removes the effect of price changes from the series so that changes that occur are more likely to reflect changes in capacity to purchase given quantities of goods or services. Measuring GDP in a common currency (US dollars), as opposed to local currencies, allows for meaningful cross-country comparisons. In this data set, a common base year of market exchange rates is used to convert each country’s GDP into a common currency.",
  },
  MacroeconomyGlossaryP2: {
    id: `${PREFIX}.Macroeconomy.GlossaryP2`,
    defaultMessage:
      "For more information on the methodology, treatment of missing values, building of projections and sources used, please visit <a target='_blank' class='HelpPage-Link' href='http://www.ers.usda.gov/data-products/international-macroeconomic-data-set/documentation/'>http://www.ers.usda.gov/data-products/international-macroeconomic-data-set/documentation/</a>. ",
  },
  MacroeconomyReleaseP1: {
    id: `${PREFIX}.Macroeconomy.ReleaseP1`,
    defaultMessage:
      "The historical data and projections are updated annually in December, while they are updated in the AP Agriculture Terminal in the following February.",
  },
  SpecialTopicsFullHeader: {
    id: `${PREFIX}.SpecialTopics.FullHeader`,
    defaultMessage: "Special topics",
  },
  SpecialTopicsConversionH: {
    id: `${PREFIX}.SpecialTopics.ConversionH`,
    defaultMessage: "Conversion",
  },
  SpecialTopicsConversionP1: {
    id: `${PREFIX}.SpecialTopics.ConversionP1`,
    defaultMessage:
      "AP Agriculture Terminal contains option to provide unified selection of data. In order to simplify crops comparison, we have converted all units into\
    Metric Units system. (Available as selection in Facts selection box -&gt; “EU Units”)",
  },
  SpecialTopicsConversionP2: {
    id: `${PREFIX}.SpecialTopics.ConversionP2`,
    defaultMessage: "Please find below file with conversion factors used:",
  },
});
